import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import VueAxios from "vue-axios";
import VuejsDialog from "vuejs-dialog";

// include the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import packageJson from "../package.json";

import App from "./App.vue";
import router from "./routes/router";
import "./assets/beast.scss";

/* eslint-disable no-undef */
Vue.config.productionTip = process.env.NODE_ENV === "development";
const beast = {
  host: BEAST_HOST || process.env.VUE_APP_BEAST_HOST,
  api: BEAST_API || process.env.VUE_APP_BEAST_API,
  version: packageJson.version,
  build: BEAST_BUILD_REVISION !== ""
    ? `${BEAST_BUILD_REVISION}`
    : "",
  config: {}
};
Vue.prototype.$beast = beast;
axios.defaults.baseURL = `${beast.host}${beast.api}`;

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VuejsDialog);
Vue.use(VueAxios, axios);
Vue.router = router;

Vue.use(require("@websanova/vue-auth"), {
  auth: {
    request(req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: `Bearer ${token}` });
    },

    response(res) {
      let { token } = res.data;
      if (!token) {
        token = this.options.http._getHeaders.call(this, res).Authorization;
      }

      if (token) {
        token = token.split(/Bearer:?\s?/i);
        return token[token.length > 1 ? 1 : 0].trim();
      }

      return null;
    }
  },
  http: require("@websanova/vue-auth/drivers/http/axios.1.x"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x"),
  authRedirect: "/auth/login",
  logoutData: { url: "auth/logout", makeRequest: true },
  fetchData: { url: "auth/user" },
  parseUserData: (data) => {
    if (data === null || data === undefined) {
      sessionStorage.removeItem("user");
    } else {
      sessionStorage.setItem("user", JSON.stringify(data));
    }
    return data;
  }
});

Vue.prototype.setTitle = (title) => {
  document.title = `${title} | ${BEAST_TITLE}`;
};

new Vue({
  router,
  render: h => h(App),
}).$mount("#app");
